<template>
  <div class="bms-panel-wrapper">
    <div class="row">
      <div class="col-12">
        <card>
          <h2 class="card-title">BMS</h2>
          <div class="table-responsive">
            <b-table
              striped
              hover
              sticky-header
              id="my-table"
              :fields="fields"
              :items="bmss"
              selectable
              :select-mode="'single'"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              sort-icon-left
              table-class="fixed-columns-table">
              <template #cell(vNominal)="data">
                {{ data.value ? data.value + ' V' : '' }}
              </template>
              <template #cell(cNominal)="data">
                {{ data.value ? data.value + ' Ah' : '' }}
              </template>
              <template #cell(techBatt)="data">
                {{ batteryTechEnum[data.value] ? batteryTechEnum[data.value] : data.value }}
              </template>
              <template #cell(received)="data">
                <b>{{ data.item.received ? "&#9989;" : ( data.item.configured ? "&#128260;" : "&#10060;") }}</b>
              </template>
              <template #cell(edit)="data">
                <button class="btn btn-link" @click="rowSelected(data.item)" >
                  <i class='tim-icons icon-pencil'></i>
                </button>
              </template>
            </b-table>
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table"
            ></b-pagination>
          </div>
          <!--
          <base-button slot="footer" type="primary-nogradient" @click="newBms()" fill>New Bms</base-button>
          -->
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import Card from '@/components/Cards/Card.vue';
import { batteryTechEnum } from '@/config/env'

export default {
    components: {
        Card
  },
  data() {
    return {
      perPage: 15,
      currentPage: 1,
      batteryTechEnum: batteryTechEnum,
      fields: [],
      selected: [],
      nextToken: '',
      sortBy: '',
      sortDesc: false
    };
  },
  watch: {
    locale : function () {
      this.fields = this.computeTableFields();
    }
  },
  computed: {
    rows() {
      return this.bmss.length
    },
    ...mapState([
      'logged',
      'isAdmin',
      'isLvl1User',
      'bmss',
      'whiteTheme',
      'calendarColor'
    ]),
    locale() {
      return this.$i18n.locale
    },
  },
  mounted() {
    this.$store.dispatch('updateBMSs')
    var handler = setInterval(function () {
      this.$store.dispatch('updateBMSs')
    }.bind(this), 5000)
    this.$store.commit('addTimerHandler', handler)
    this.fields = this.computeTableFields();
  },
  methods: {
    ...mapMutations([
      'setBMSs'
    ]),
    rowSelected(bms) {
      if(bms) {
        console.log("Selected bms")
        console.log(bms)
        localStorage.setItem("selectedBms", JSON.stringify(bms))
        this.$router.push('edit-bms')
      }
    },
    newBms() {
      localStorage.setItem("selectedBms", JSON.stringify({}))
      this.$router.push('edit-bms')
    },
    computeTableFields() {
      let fields = [{
          key: 'bms_id',
          label: 'id',
          sortable: true,
          thStyle: { width: '120px', minWidth: '120px' }},
        {
          key: 'renterName',
          label: this.$i18n.t('bmsPanel.renter'),
          sortable: true,
          thStyle: { width: '150px', minWidth: '150px' }},
        {
          key: 'alias',
          label: this.$i18n.t('bmsPanel.alias'),
          sortable: true,
          thStyle: { width: '150px', minWidth: '150px' }},
        {
          key: 'vNominal',
          label: this.$i18n.t('bmsPanel.nominalVoltage'),
          sortable: true,
          thStyle: { width: '120px', minWidth: '120px' }},
        {
          key: 'cNominal',
          label: this.$i18n.t('bmsPanel.nominalCapacity'),
          sortable: true,
          thStyle: { width: '120px', minWidth: '120px' }},
        {
          key: 'techBatt',
          label: this.$i18n.t('bmsPanel.batteryTech'),
          sortable: true,
          thStyle: { width: '130px', minWidth: '130px' }},
        {
          key: 'received',
          label: this.$i18n.t('bmsPanel.configured'),
          thStyle: { width: '110px', minWidth: '110px' }},
        {
          key: 'edit',
          label: this.$i18n.t('bmsPanel.edit'),
          thStyle: { width: '80px', minWidth: '80px' }},
        ]
      if(this.isAdmin || this.isLvl1User) fields.unshift({
        key: 'ownerName',
        label: this.$i18n.t('bmsPanel.username'),
        sortable: true,
        thStyle: { width: '150px', minWidth: '150px' }},
      );
      return fields
    }
  }
};
</script>
<style>
.table-responsive {
  overflow-x: auto;
  overflow-y: hidden;
}

.table-responsive::-webkit-scrollbar {
  height: 8px;
}

.table-responsive::-webkit-scrollbar-track {
  background: transparent;
}

.table-responsive::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
}

.table-responsive::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

.fixed-columns-table {
  table-layout: fixed;
}
.fixed-columns-table th,
.fixed-columns-table td {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Icone di ordinamento personalizzate per Bootstrap Vue */
.fixed-columns-table th[aria-sort] {
  cursor: pointer;
  user-select: none;
  position: relative;
  padding-left: 1.75rem !important;
}

.fixed-columns-table th[aria-sort]:hover {
  opacity: 0.8;
}

.fixed-columns-table th[aria-sort]::before {
  content: '';
  position: absolute;
  left: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
}

/* Stato non ordinato - freccia doppia */
.fixed-columns-table th[aria-sort="none"]::before {
  border-bottom: 4px solid rgba(255, 255, 255, 0.3);
  border-top: none;
  margin-top: -3px;
}

.fixed-columns-table th[aria-sort="none"]::after {
  content: '';
  position: absolute;
  left: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid rgba(255, 255, 255, 0.3);
  border-bottom: none;
  margin-top: 3px;
}

/* Ordinamento crescente - freccia SU (triangolo verso l'alto) */
.fixed-columns-table th[aria-sort="ascending"]::before {
  border-top: none;
  border-bottom: 7px solid #fff;
}

/* Ordinamento decrescente - freccia GIÙ (triangolo verso il basso) */
.fixed-columns-table th[aria-sort="descending"]::before {
  border-bottom: none;
  border-top: 7px solid #fff;
}

/* Stili per tema chiaro */
.white-content .fixed-columns-table th[aria-sort="none"]::before {
  border-bottom: 4px solid rgba(0, 0, 0, 0.3);
}

.white-content .fixed-columns-table th[aria-sort="none"]::after {
  border-top: 4px solid rgba(0, 0, 0, 0.3);
}

.white-content .fixed-columns-table th[aria-sort="ascending"]::before {
  border-bottom: 7px solid #222;
}

.white-content .fixed-columns-table th[aria-sort="descending"]::before {
  border-top: 7px solid #222;
}
</style>
